export default {"src":"/_next/static/media/password-form.10c0a6a7.svg","height":121,"width":280};